import { ApiProperty } from '@nestjs/swagger'

/**
 * Réponse pour les statistiques personnelles de l'utilisateur
 */
export class AttemptStatisticsResponseDto {
  @ApiProperty({
    description: 'Nombre total de tentatives',
    example: 42,
  })
  totalAttempts!: number

  @ApiProperty({
    description: 'Nombre de tentatives réussies',
    example: 35,
  })
  passed!: number

  @ApiProperty({
    description: 'Nombre de tentatives notées',
    example: 40,
  })
  graded!: number

  @ApiProperty({
    description: 'Nombre de tentatives en attente de notation',
    example: 2,
  })
  pending!: number

  @ApiProperty({
    description: 'Score moyen (arrondi à 2 décimales)',
    example: 85.5,
  })
  averageScore!: number

  @ApiProperty({
    description: 'Taux de réussite en pourcentage',
    example: 87.5,
  })
  successRate!: number
}

